import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMaskDirective } from 'ngx-mask';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { ToolsModule } from '@app/components/shared/tools/tools.module';
import { AngularMaterialModule } from '@app/components/shared/angular-material/angular-material.module';
import { CardsModule } from '@app/components/shared/cards/cards.module';
import { PipesModule } from '@app/components/pipes/pipes.module';
import { DialogsModule } from '@app/components/shared/dialogs/dialogs.module';
import { PublicWidgetsModule } from '@app/components/shared/public-widgets/public-widgets.module';

import { SosMaterialsRoutingModule, materialComponents } from './sos-materials.routing';

import { ViewDetailedMaterialComponent } from './view-detailed-material/view-detailed-material.component';
import { EditMaterialComponent } from './edit-material/edit-material.component';

@NgModule({
    declarations: [
        materialComponents
    ],
    exports: [
        ViewDetailedMaterialComponent,
        EditMaterialComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        NgxMaskDirective,
        NgMultiSelectDropDownModule,
        InfiniteScrollModule,
        ToolsModule,
        AngularMaterialModule,
        SosMaterialsRoutingModule,
        PipesModule,
        DialogsModule,
        PublicWidgetsModule,
        CardsModule
    ], 
    providers: [provideHttpClient(withInterceptorsFromDi())] 
})

export class SosMaterialsModule { }